import { ReactNode, useState } from "react";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { EuiButton } from "@inscopix/ideas-eui";
import { ModalCreateTestTable } from "./ModalCreateTestTable";

export interface ButtonCreateTestTableProps {
  onComplete?: () => void;
}
export const ButtonCreateTestTable = ({
  onComplete,
}: ButtonCreateTestTableProps) => {
  const hasTestTable = useToolEditorContext((s) => s.testTable !== null);
  const createTestTable = useToolEditorContext((s) => s.createTestTable);

  const status = useToolEditorContext((s) => s.draftSpecSaveStatus);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState<ReactNode>(null);

  const handleExecuteCreateTestTable = async () => {
    setLoading(true);
    await createTestTable();
    setLoading(false);
    setModal(null);
    onComplete?.();
  };

  const handleCreateTestTable = () => {
    if (hasTestTable) {
      setModal(
        <ModalCreateTestTable
          closeModal={() => setModal(null)}
          createTable={handleExecuteCreateTestTable}
        />,
      );
    } else {
      void handleExecuteCreateTestTable();
    }
  };

  return (
    <>
      {modal}
      <EuiButton
        onClick={handleCreateTestTable}
        isLoading={loading}
        disabled={status !== "SAVED"}
      >
        Create Test Table
      </EuiButton>
    </>
  );
};
